import type { TButtonColor } from "../types";

type TButtonVariantProps = {
  wrapperClass: string;
  textClass: string;
  image?: {
    src: string;
    alt: string;
  };
};

type TButtonVariants = {
  [key in TButtonColor]: TButtonVariantProps;
};

export const buttonVariants: TButtonVariants = {
  darkBlue: {
    wrapperClass: "bg-blue-500",
    textClass: "text-white",
    image: {
      src: "/static/icons/white-arrow-right.svg",
      alt: "white-arrow-icon",
    },
  },
  lightBlue: {
    wrapperClass: "bg-gray-180",
    textClass: "text-blue-500",
    image: {
      src: "/static/icons/blue-arrow-right.svg",
      alt: "blue-arrow-icon",
    },
  },
  white: {
    wrapperClass: "bg-white",
    textClass: "text-blue-500",
    image: {
      src: "/static/icons/blue-arrow-right.svg",
      alt: "blue-arrow-icon",
    },
  },
  outline: {
    wrapperClass: "bg-white border border-gray-190",
    textClass: "text-gray-800",
  },
};
